const commonsConfig = {
  onSignIn: async () => {
    window.location.hash = '';
  },
  redirectUri: `https://${window.location.hostname}/curadoria`,
  responseType: 'code',
  scope: 'openid',
  postLogoutRedirectUri: `https://${window.location.hostname}/curadoria/logout`,
};

const configs = {
  DES: {
    login_unico: {
      alias: 'login_unico',
      authority: 'https://d-keycloak.estaleiro.serpro.gov.br/auth/realms/serpro',
      clientId: 'd_serprobot_curadoria_d',
      clientSecret: 'd28650a3-2e27-4d89-a99b-c1a1fed78a1a',
      ...commonsConfig,
    },
    govbr: {
      alias: 'govbr',
      authority: 'https://sso.staging.acesso.gov.br',
      clientId: 'd-serprobots.estaleiro.serpro.gov.br',
      clientSecret: 'VMvEH6Jx7MmY1Rd1WT844R09e06fbodcjb1SoL4XqcgQsCemy9aF7wFyeM8YPoQ1fIBkxB3AO5onguRjDvP5Dg',
      ...commonsConfig,
      scope: 'openid email phone profile govbr_empresa govbr_confiabilidades',
    },
  },  
  EXT: {
    login_unico: {
      alias: 'login_unico',
      authority: 'https://d-keycloak.estaleiro.serpro.gov.br/auth/realms/serpro',
      clientId: 'd_ext_serprobots',
      clientSecret: 'ikKouhb4muLBaJAjnkXDmU5UFL0VE9LU',
      ...commonsConfig,
    },
    govbr: {
      alias: 'govbr',
      authority: 'https://sso.staging.acesso.gov.br',
      clientId: 'd-serprobots.estaleiro.serpro.gov.br',
      clientSecret: 'VMvEH6Jx7MmY1Rd1WT844R09e06fbodcjb1SoL4XqcgQsCemy9aF7wFyeM8YPoQ1fIBkxB3AO5onguRjDvP5Dg',
      ...commonsConfig,
      scope: 'openid email phone profile govbr_empresa govbr_confiabilidades',
    },
  },
  HOM: {
    login_unico: {
      alias: 'login_unico',
      authority: 'https://d-keycloak.estaleiro.serpro.gov.br/auth/realms/serpro',
      clientId: 'h_serprobot_curadoria_h',
      clientSecret: '466093f8-a41c-43e5-ad18-90ade5a9eb87',
      ...commonsConfig,
    },
    govbr: {
      alias: 'govbr',
      authority: 'https://sso.staging.acesso.gov.br',
      clientId: 'd-serprobots.estaleiro.serpro.gov.br',
      clientSecret: 'VMvEH6Jx7MmY1Rd1WT844R09e06fbodcjb1SoL4XqcgQsCemy9aF7wFyeM8YPoQ1fIBkxB3AO5onguRjDvP5Dg',
      ...commonsConfig,
      scope: 'openid email phone profile govbr_empresa govbr_confiabilidades',
    },
  },
  TRE: {
    login_unico: {
      alias: 'login_unico',
      authority: 'https://login.serpro.gov.br/auth/realms/serpro',
      clientId: 't_serprobots',
      clientSecret: 'ibQU2oTAH8IjDzChHgaIRDvQp01hbQud',
      ...commonsConfig,
    },
    govbr: {
      alias: 'govbr',
      authority: 'https://sso.acesso.gov.br',
      clientId: 'serprobots.estaleiro.serpro.gov.br',
      clientSecret: 'APOoiwbbPBST7RhUGZ1JWHwLBW5k-HJBcKPl8oVHwAyzYT2QIABb1g06YvmE2II5ZYsgPZVGYhdYpecJ1agBBuM',
      ...commonsConfig,
      scope: 'openid email phone profile govbr_empresa govbr_confiabilidades',
    },
  },
  PRO: {
    login_unico: {
      alias: 'login_unico',
      authority: 'https://login.serpro.gov.br/auth/realms/serpro',
      clientId: 'serprobot_curadoria_p',
      clientSecret: '3647f325-df89-4c44-98c6-8620a87cd454',
      ...commonsConfig,
    },
    govbr: {
      alias: 'govbr',
      authority: 'https://sso.acesso.gov.br',
      clientId: 'serprobots.estaleiro.serpro.gov.br',
      clientSecret: 'APOoiwbbPBST7RhUGZ1JWHwLBW5k-HJBcKPl8oVHwAyzYT2QIABb1g06YvmE2II5ZYsgPZVGYhdYpecJ1agBBuM',
      ...commonsConfig,
      scope: 'openid email phone profile govbr_empresa govbr_confiabilidades',
    },
  },
  LOCAL: {
    login_unico: {
      alias: 'login_unico',
      authority: 'http://localhost:8180/auth/realms/serpro',
      clientId: 'serprobots_local',
      clientSecret: '3647f325-df89-4c44-98c6-8620a87cd454',
      ...commonsConfig,
      redirect_uri: 'http://localhost:3000/curadoria',
    },
    govbr: {
      alias: 'govbr',
      authority: 'https://sso.staging.acesso.gov.br',
      clientId: 'd-serprobots.estaleiro.serpro.gov.br',
      clientSecret: 'd28650a3-2e27-4d89-a99b-c1a1fed78a1a',
      ...commonsConfig,
      scope: 'openid email phone profile govbr_empresa govbr_confiabilidades',
    },
  },
};

let providerConfig = null;
switch (window.location.hostname) {
  case 'd-serprobots.estaleiro.serpro.gov.br':
  {
    providerConfig = configs.DES;
    break;
  }
  case 'h-serprobots.estaleiro.serpro.gov.br':
  {
    providerConfig = configs.HOM;
    break;
  }
  case 'ext-serprobots.estaleiro.serpro.gov.br':
  {
    providerConfig = configs.EXT;
    break;
  }
  case 't-serprobots.estaleiro.serpro.gov.br':
  {
    providerConfig = configs.TRE;
    break;
  }
  case 'serprobots.ia.serpro.gov.br':
  {
    providerConfig = configs.PRO;
    break;
  }
  case 'serprobots.estaleiro.serpro.gov.br':
  {
    providerConfig = configs.PRO;
    break;
  }
  case 'localhost':
  {
    providerConfig = configs.LOCAL;
    break;
  }
  default:
    break;
}

const configuration = providerConfig || null;

export default configuration;
